import { render, staticRenderFns } from "./ProblemDetailView.vue?vue&type=template&id=1944a804&scoped=true&"
import script from "./ProblemDetailView.vue?vue&type=script&lang=js&"
export * from "./ProblemDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ProblemDetailView.vue?vue&type=style&index=0&id=1944a804&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1944a804",
  null
  
)

export default component.exports